import type {
  TVideobroadcastSerializedInternalState,
  VideobroadcastWidgetEntity,
} from '../../../pages/dashboard/features/videobroadcast-widget/VideobroadcastWidget.entity';

export function serializeVideoBroadcastTemplate(widget: VideobroadcastWidgetEntity) {
  const internalState: TVideobroadcastSerializedInternalState = {
    wellId: null,
    stateParams: {
      aspectRatio: widget.stateParams.aspectRatio,
      camerasOrder: widget.stateParams.camerasOrder,
      selectedCameras: widget.stateParams.selectedCameras,
      playAll: widget.stateParams.playAll,
      playbackMode: widget.stateParams.playbackMode,
      playbackTimeMs: widget.stateParams.playbackTimeMs,
      wellboreId: widget.stateParams.wellboreId,
      additionalInfo: widget.stateParams.additionalInfo,
    },
  };
  return {
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    internalState,
  };
}
